import React from 'react';
import Loadable from 'react-loadable';

import { UFOHold } from '@townsquare/gemini/ufo-hold';

export const HelpPanel = Loadable({
  loader: () => import(/* webpackChunkName: "Help" */ './Help'),
  loading: () => <UFOHold name="loading-help-panel" />,
});
